import EnglishFlagIcon from '@stripcash/ui-kit/icons/englishFlag.svg';
import RussianFlagIcon from '@stripcash/ui-kit/icons/russianFlag.svg';
import SpanishFlagIcon from '@stripcash/ui-kit/icons/spanishFlag.svg';
import JapaneseFlagIcon from '@stripcash/ui-kit/icons/japaneseFlag.svg';
import ChineseFlagIcon from '@stripcash/ui-kit/icons/chineseFlag.svg';
import KoreanFlagIcon from '@stripcash/ui-kit/icons/koreanFlag.svg';

export const LANGUAGE_POPUP_ID = 'LanguagePopupId';
export const DEFAULT_LANGUAGE = {
  code: 'en',
  name: 'English',
};

export const ICONS_BY_LANGUAGE = {
  ko: <KoreanFlagIcon />,
  en: <EnglishFlagIcon />,
  ru: <RussianFlagIcon />,
  es: <SpanishFlagIcon />,
  ja: <JapaneseFlagIcon />,
  zh: <ChineseFlagIcon />,
};
